import { useEffect, useState } from 'react';
import { CheckCircle, XCircle, AlertCircle, Info, X } from 'lucide-react';
import './Snackbar.scss';

const Snackbar = ({ message, type = 'info', duration = 4000, onClose }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(() => {
                handleClose();
            }, duration);

            return () => clearTimeout(timer);
        }
    }, [duration]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            setIsVisible(false);
            onClose?.();
        }, 300); // Match animation duration
    };

    if (!isVisible) return null;

    const icons = {
        success: CheckCircle,
        error: XCircle,
        warning: AlertCircle,
        info: Info
    };

    const Icon = icons[type] || Info;

    return (
        <div className={`snackbar snackbar-${type} ${isExiting ? 'snackbar-exit' : 'snackbar-enter'}`}>
            <div className="snackbar-content">
                <Icon className="snackbar-icon" size={20} />
                <span className="snackbar-message">{message}</span>
            </div>
            <button className="snackbar-close" onClick={handleClose} aria-label="Close">
                <X size={16} />
            </button>
        </div>
    );
};

export default Snackbar;
